// eslint-disable-next-line import/prefer-default-export
export const JOB_STATUS = {
  AWAITING_PROCESSING: 'AwaitingProcessing',
  PROCESSING: 'Processing',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  FAILED: 'Failed',
};
